import React from 'react';
import cn from 'classnames';
import { EMBED_ROUTES } from 'constants/config';
import ReactHtml from 'components/shared/ReactHtml';
import { useColors } from 'ui/hooks';
import { Icon } from 'ui';
import ZiggeoMediaPlayer from 'ui/ZiggeoVideo/ZiggeoMediaPlayer';
import UniversalPlayer from 'components/shared/UniversalPlayer';
import { urlIsZiggeo } from 'utils/url';
import { IEmbedProps } from './types';

export const Embed = ({ data }) => {
  const { colorPrimary } = useColors();
  if (!data) return null;
  const ziggeoToken = urlIsZiggeo(data.url);
  const embedId = data.id;

  return (
    <>
      <div
        className={cn('media', { other: data.other })}
        data-behavior="embed_container"
      >
        {data.isSeismic && (
          <UniversalPlayer id={embedId} videoType="Embed" isPractice />
        )}
        {!data.isSeismic && data.wistiaId && (
          <iframe
            src={EMBED_ROUTES.WISTIA_IFRAME(data.wistiaId, colorPrimary)}
            title={data.wistiaId}
            allowtransparency="true"
            frameBorder="0"
            scrolling="no"
            name="wistia_embed"
            allowFullScreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen
            width="640"
            height="360"
          />
        )}
        {!data.isSeismic && !data.wistiaId && !ziggeoToken && (
          <ReactHtml THE_DATA_HAS_BEEN_SANITIZED>
            {data.embeddedContent}
          </ReactHtml>
        )}
        {!data.isSeismic && !data.wistiaId && ziggeoToken && (
          <ZiggeoMediaPlayer
            token={ziggeoToken}
            apiKey={data.ziggeoApiKey}
            className="maxh-600"
          />
        )}
      </div>

      {data.isGoogleDoc && (
        <div className="clearfix">
          <a
            href={data.url}
            className="Document-actionLink"
            target="_blank"
            rel="noreferrer"
          >
            <Icon name="link" /> {t('lessons.elements.links.source')}
          </a>
        </div>
      )}

      {data.caption && (
        <figcaption>
          <ReactHtml>{data.caption}</ReactHtml>
        </figcaption>
      )}
    </>
  );
};

Embed.propTypes = IEmbedProps;

export default Embed;
